jQuery(function ($) {
  if ($('.HittaTipsSida').length) {
    $(document).on('click', '.content-id', function () {
      var pid = $(this).attr('data-id');
      $('#modal-' + pid).toggle();
      $('#message-' + pid).hide();
    });

    $(document).on('click', '.copyurl', function () {
      var pid = $(this).attr('data-id');
      var inputString = $('#input-' + pid).val();
      if (copyToClipboard(inputString)) {
        $('#message-' + pid).show();
      }
      $(this).focus();
    });

    $(document).on('mouseup', function (e) {
      var container = $('.link-modal');

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
      }
    });
  }
});

function copyToClipboard(text) {
  if (navigator.clipboard) {
    return navigator.clipboard
      .writeText(text)
      .then(() => 'successful')
      .catch((err) => {
        console.error('Failed to copy: ', err);
        return 'unsuccessful';
      });
  } else {
    // Fallback for browsers that do not support the Clipboard API
    var tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();

    try {
      var successful = document.execCommand('copy');
      document.body.removeChild(tempTextArea);
      return successful ? 'successful' : 'unsuccessful';
    } catch (err) {
      document.body.removeChild(tempTextArea);
      console.error('Failed to copy: ', err);
      return 'unsuccessful';
    }
  }
}
